import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as Const from 'util/constants';
import './BundleTypeBar.scss';
import { selectBundleType } from 'actions/user';

export class BundleTypeBar extends Component {
  static propTypes = {
    setBundleType: PropTypes.func,
    currentBundleType: PropTypes.string,
    className: PropTypes.string,
    isPurchased: PropTypes.bool
  };

  componentDidMount() {
    const { className, currentBundleType, setBundleType } = this.props;
    if (className && !currentBundleType) setBundleType(className);
  }

  selectBundleType = type => {
    const { history, setBundleType, isPurchased } = this.props;
    if (!isPurchased) setBundleType(type);
    history.push(`${isPurchased ? '/my-purchases' : ''}/${type}`);
  };

  render() {
    const { className } = this.props;
    return (
      <div className={classNames('type-filter d-flex align-items-center', className)}>
        <button
          className={classNames({ active: className === Const.TYPE_IMAGE_BUNDLES })}
          onClick={() => this.selectBundleType(Const.TYPE_IMAGE_BUNDLES)}
        >
          Images
        </button>
        <button
          className={classNames({ active: className === Const.TYPE_AUDIO_BUNDLES })}
          onClick={() => this.selectBundleType(Const.TYPE_AUDIO_BUNDLES)}
        >
          Audios
        </button>
        <button
          className={classNames({ active: className === Const.TYPE_TEMPLATES })}
          onClick={() => this.selectBundleType(Const.TYPE_TEMPLATES)}
        >
          Templates
        </button>
        <div className="selector" />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  currentBundleType: state.user.bundleType
});

const mapDispatchToProps = dispatch => ({
  setBundleType: type => dispatch(selectBundleType(type, true))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BundleTypeBar));
